import axios from 'axios'
import React, { Component } from 'react'
import { Col, Row, Button } from 'react-bootstrap'
import { addCommas } from '../utils/utils'
import { API_URL } from '../utils/constant'
import { Link } from 'react-router-dom'

export default class TotalBayar extends Component {
    submitTotalBayar = (totalBayar) => {

        const pesanan = {
            total_bayar: totalBayar,
            menus: this.props.keranjangs
        }

        axios
            .post(API_URL + "pesanans", pesanan)
            .then((res) => {
                this.props.history.push('/')
            })
            .catch(error => {
                console.log(error)
            })
    }

    render() {

        const totalBayar = this.props.keranjangs.reduce(function (result, item) {
            return result + item.total_harga
        }, 0)

        return (
            <>
                {/* WEB */}
                <div className="fixed-bottom d-none d-md-block">
                    <Row>
                        <Col md={{ span: 3, offset: 9 }} className="px-4">
                            <h4>
                                Total Harga :{" "}
                                <strong className="float-end mr-2">
                                    Rp. {addCommas(totalBayar)}
                                </strong>
                            </h4>
                            <div className="d-grid gap-2">
                                <Button variant="primary" className="mb-2 mt-2 mr-2" size="lg"
                                    onClick={() => this.submitTotalBayar(TotalBayar)} as={Link} to='/success'>
                                    <strong>BAYAR</strong>
                                </Button>
                            </div>

                        </Col>
                    </Row>
                </div>

                {/* MOBILE */}
                <div className="d-sm-block d-md-none ">
                    <Row>
                        <Col md={{ span: 3, offset: 9 }} className="px-4">
                            <h4>
                                Total Harga :{" "}
                                <strong className="float-end mr-2">
                                    Rp. {addCommas(totalBayar)}
                                </strong>
                            </h4>
                            <div className="d-grid gap-2">
                                <Button variant="primary" className="mb-2 mt-2 mr-2" size="lg"
                                    onClick={() => this.submitTotalBayar(TotalBayar)} as={Link} to='/success'>
                                    <strong>BAYAR</strong>
                                </Button>
                            </div>

                        </Col>
                    </Row>
                </div>
            </>
        )
    }
}
